export default {
    'name': 'check',
    'width': '24',
    'height': '24',
    'viewBox': '0 0 24 24',
    'data': '<path fill-rule=\'evenodd\' clip-rule=\'evenodd\' d=\'M19.8956 7.28033C20.1885 6.98744 20.1885 6.51256 19.8956 6.21967C19.6027 5.92678 19.1278 5.92678 18.8349 6.21967L8.62977 16.4248L4.28033 12.0754C3.98744 11.7825 3.51256 11.7825 3.21967 12.0754C2.92678 12.3683 2.92678 12.8432 3.21967 13.136L8.09944 18.0158C8.39233 18.3087 8.8672 18.3087 9.1601 18.0158L19.8956 7.28033Z\' fill=\'#026958\'/>'
}
